'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require('react-bootstrap');

var _translate = require('../../language/translate');

var _LabelledInputComponent = require('../input/LabelledInputComponent');

var _LabelledInputComponent2 = _interopRequireDefault(_LabelledInputComponent);

var _RecurringPaymentsComponent = require('../input/RecurringPaymentsComponent');

var _RecurringPaymentsComponent2 = _interopRequireDefault(_RecurringPaymentsComponent);

var _SelectComponent = require('../input/SelectComponent');

var _SelectComponent2 = _interopRequireDefault(_SelectComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Renders a box displaying the current application quote estimate,
 * as well as any possible details regarding this estimate.
 * @extends {Component}
 */
var QuoteComponent = function (_React$Component) {
  _inherits(QuoteComponent, _React$Component);

  function QuoteComponent() {
    _classCallCheck(this, QuoteComponent);

    return _possibleConstructorReturn(this, (QuoteComponent.__proto__ || Object.getPrototypeOf(QuoteComponent)).apply(this, arguments));
  }

  _createClass(QuoteComponent, [{
    key: 'isRecurringPaymentEnabled',
    value: function isRecurringPaymentEnabled() {
      return this.props.fields.payment.payment_option.value === 'monthly';
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'ingle-form-quote quote-box' },
          this.isRecurringPaymentEnabled() ? _react2.default.createElement(_RecurringPaymentsComponent2.default, this.props) : null,
          _react2.default.createElement(
            'table',
            { className: 'quote-table' },
            _react2.default.createElement(
              'tbody',
              null,
              _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'td',
                  null,
                  _react2.default.createElement(
                    'h2',
                    { className: 'display-price quote-price-display' },
                    _react2.default.createElement(
                      'p',
                      { className: 'quote-lines' },
                      (0, _translate.t)('Your Quote'),
                      ': ',
                      this.props.quoteAmount ? this.props.quoteAmount : this.props.initialQuoteAmount + ' ' + this.props.quoteCurrency
                    ),
                    this.props.application.payment.reference_id ? _react2.default.createElement(
                      'p',
                      { className: 'quote-lines quote-reference' },
                      (0, _translate.t)('Application ID'),
                      ': ',
                      this.props.application.payment.reference_id
                    ) : null
                  )
                )
              ),
              function () {
                if (_this2.props.quoteDetails) {
                  return _react2.default.createElement(
                    'tr',
                    null,
                    _react2.default.createElement(
                      'td',
                      null,
                      _react2.default.createElement(
                        'p',
                        { className: 'quote-lines' },
                        _this2.props.quoteDetails
                      )
                    )
                  );
                }

                return null;
              }()
            )
          )
        )
      );
    }
  }]);

  return QuoteComponent;
}(_react2.default.Component);

QuoteComponent.propTypes = {
  initialQuoteAmount: _react2.default.PropTypes.string,
  quoteAmount: _react2.default.PropTypes.string,
  quoteDetails: _react2.default.PropTypes.string,
  quoteCurrency: _react2.default.PropTypes.string,
  fields: _react2.default.PropTypes.object,
  application: _react2.default.PropTypes.object
};
QuoteComponent.defaultProps = {
  initialQuoteAmount: '$0.00',
  quoteDetails: 'null',
  quoteCurrency: 'CAD'
};
exports.default = QuoteComponent;


//////////////////
// WEBPACK FOOTER
// ./src/v2/components/common/QuoteComponent.jsx
// module id = 807
// module chunks = 0